import { Routes } from '@angular/router';
import {
  AuthGuard,
  DEFAULT_USER_MANAGEMENT_ROUTES,
  LoginRedirectGuard,
  moduleDefaultRedirectGuard,
  moduleMatchGuard,
} from '@core';
import { LayoutComponent } from '@shell';
import { EMS_ROUTES } from './routes/ems.routes';
import { LoginPageComponent } from './feature/login-page/login-page.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [LoginRedirectGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      // {
      //   path: '',
      //   canMatch: [moduleMatchGuard('RMS')],
      //   children: RMS_ROUTES,
      // },
      {
        path: '',
        canMatch: [moduleMatchGuard('EMS')],
        children: EMS_ROUTES,
      },
      {
        path: '',
        canMatch: [moduleMatchGuard('user_management')],
        children: DEFAULT_USER_MANAGEMENT_ROUTES,
      },
      {
        path: '**',
        canMatch: [moduleDefaultRedirectGuard],
        children: [],
      },
    ],
  },
];
